import {
  Panel,
  SPACING_8,
  SpacingVertical,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import ExistingContent from './ExistingContent'
import InputFile from './InputFile'

const BoxFileUploader = () => {
  const intl = useIntl()
  return (
    <>
      <Title variant={TITLE_VARIANT_M}>
        {intl.formatMessage({
          id: 'Load.ContentsSouces.UpdateDataCollect'
        })}
      </Title>
      <SpacingVertical variant={SPACING_8} />
      <Panel>
        <InputFile />
      </Panel>
      <ExistingContent />
    </>
  )
}

export default BoxFileUploader
